// Frontend-safe Zoho Payments config. Nothing here is a secret — the real
// Client Secret and refresh token live only in the Worker
// (../../zoho-payments-worker), never in this bundle.

export const ZOHO_PAYMENTS = {
  // Backend that creates payment sessions — see zoho-payments-worker/.
  workerUrl:
    process.env.REACT_APP_ZOHO_WORKER_URL ||
    "https://rango-zoho-payments.rangocycles.workers.dev",

  // From Zoho Payments > Settings > Account Details.
  accountId: process.env.REACT_APP_ZOHO_ACCOUNT_ID || "60082388992",

  // Two-letter data center. India account.
  domain: "IN",

  // From Zoho Payments > Settings > Developer Space > Authentication Keys.
  // Must be set via a .env file (see .env.example) — no default, so a
  // missing key fails loudly instead of silently trying to charge with "".
  apiKey: process.env.REACT_APP_ZOHO_API_KEY || "",

  // Set REACT_APP_ZOHO_TEST_MODE=true while testing against the sandbox.
  testMode: process.env.REACT_APP_ZOHO_TEST_MODE === "true",
};

export default ZOHO_PAYMENTS;
